import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';
import RenderStatusTag from 'zComponents/atoms/RenderStatusTag';

dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(relativeTime);

export const getCurrentTime = () => {
	const currentDate = dayjs();
	const formattedTime = currentDate.format('HH:mm');
	return formattedTime;
};

export const formatDates = (dateStr) => {
	const date = dayjs(dateStr);
	return date.format('ddd, D MMM');
};

export function isDateInFuture(date) {
	const today = dayjs();
	return dayjs(date).isAfter(today);
}

export function currentAcceptableDate() {
	return dayjs();
}

const calculateBookingStatus = (startTime, endTime, deletedDate, isFilter, bookingStatusType) => {
	const startTime2 = dayjs(startTime).local();
	const endTime2 = dayjs(endTime).local();

	switch (true) {
		case deletedDate !== null:
			return isFilter ? bookingStatusType[4].title : RenderStatusTag(bookingStatusType[4].title, 'red');
		case dayjs().isBefore(startTime2):
			return isFilter ? bookingStatusType[2].title : RenderStatusTag(bookingStatusType[2].title, 'gold');
		case dayjs().isBetween(startTime2, endTime2):
			return isFilter ? bookingStatusType[1].title : RenderStatusTag(bookingStatusType[1].title, 'green');
		case dayjs().isAfter(endTime2):
			return isFilter ? bookingStatusType[3].title : RenderStatusTag(bookingStatusType[3].title, 'blue');
		default:
			return isFilter ? bookingStatusType[5].title : RenderStatusTag(bookingStatusType[5].title);
	}
};

// Helper function to get the last login date
export const getLastLogin = (lastLogin) => {
	if (!lastLogin) return '-';

	// Get the last login date  and convert to local timezone for comparison
	const lastLoginDate = dayjs(lastLogin).local();

	// Get today and yesterday in the local timezone
	const today = dayjs().startOf('day');
	const yesterday = dayjs().subtract(1, 'day').startOf('day');

	if (lastLoginDate.isSame(today, 'day')) {
		return 'Today';
	}

	if (lastLoginDate.isSame(yesterday, 'day')) {
		return 'Yesterday';
	}

	//If is not today or yesterday, format the date as D/MM/YY
	return lastLoginDate.format('D/MM/YY');
};

// Helper function to calculate remaining duration
export const getRemainingDuration = (bookings) => {
	if (!bookings?.length) return '-';

	if (bookings.length === 0) return '-';

	const { endTime } = bookings[0];

	return dayjs.duration(dayjs(endTime).diff(dayjs())).humanize().replace(/^an? /, '1 ');
};

// Helper function to get the last unlocked info
export const getLastUnlocked = (logs) => {
	if (!logs || logs.length === 0) return '-';

	const validLogs = logs
		.filter((log) => log.method) // filter out null/undefined methods
		.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)); // sort by date descending

	const lastLog = validLogs[0];

	if (!lastLog) return '-';

	return `${lastLog.method} - ${dayjs(lastLog.createdDate).format('D/MM/YY')}`;
};

export const filterPeopleByFilters = (people, bookingsData, logsData, filters) => {
	if (filters.length === 0) return people;

	return people.filter((person) => {
		const personBookings = bookingsData.filter((b) => b.assignedToPerson === person.personID);
		const personLogs = logsData.filter((l) => l.personID === person.personID);

		// check if person matches ANY of the selected filters
		return filters.some((filter) => {
			return filter.filter(person, personBookings, personLogs);
		});
	});
};

export const getBookingState = (booking) => {
	const currentTime = dayjs();
	const startTime = dayjs(booking.startTime + 'Z');
	const endTime = dayjs(booking.endTime + 'Z');

	if (currentTime.isBefore(startTime)) {
		return 'Upcoming';
	}

	if (currentTime.isBetween(startTime, endTime)) {
		return 'Active';
	}

	return 'Expired';
};

export default calculateBookingStatus;
